import InitPerson from "../InitPerson";
interface OrbitalPanelProps {
  activeCharacters: number[];
  answers: Array<{ idCharecter: number; input: string }>;
  handleChange: (id: number, value: string) => void;
  getCallImg: (id: number) => string;
}
;
const personMap = Object.fromEntries(InitPerson.map((p) => [p.id, p]));

const OrbitalPanel: React.FC<OrbitalPanelProps> = ({ activeCharacters, answers, handleChange, getCallImg }) => { 
    return(
        <div className="hotel-panel">
        {activeCharacters.map((id) => {
          const person = personMap[id];
          const answer = answers.find((a) => a.idCharecter === id);

          return (
            <div key={id} className="hotel-row">
              <div className="hotel-avatardiv">
                <img src={person?.svgUrl} className="hotel-avatar" alt="" />
              </div>

              <input
                data-testid="answer-input"
                value={answer?.input || ""}
                className={`hotel-input`}
                onChange={(e) => handleChange(id, e.target.value)}
              />

              <div className="hotel-call">
                <img src={getCallImg(id)} className="hotel-callImg" alt="" />
              </div>
            </div>
          );
        })}
      </div>
    )}
export default OrbitalPanel;